/* eslint-disable prefer-destructuring */
const ENV = process.env.NODE_ENV;

const PROD_ENV = ENV === 'production';
const DEV_ENV = !PROD_ENV;
const ENV_NAME = process.env.ENV_NAME;
const APP_NAME = process.env.APP_NAME;
const API_URI = process.env.API_URI;
const CHAT_ATTACHMENTS_URI = process.env.CHAT_ATTACHMENTS_URI;
const CHAT_SOCKET_URI = process.env.CHAT_SOCKET_URI;
const BRAND_NAME = process.env.BRAND_NAME || 'HEALTHFULLY';
const PAYA_ORIGIN = process.env.PAYA_ORIGIN;
const WEB_APP_URL = process.env.WEB_APP_URL;
const APP_STORE_APP_LINK = process.env.APP_STORE_APP_LINK;
const PLAY_MARKET_APP_LINK = process.env.PLAY_MARKET_APP_LINK;
const REACT_APP_GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const REFRESH_SESSION_INTERVAL = process.env.REFRESH_SESSION_INTERVAL;
const WEB_PROVIDER_APP_URL = process.env.WEB_PROVIDER_APP_URL;
const APP_VERSION = process.env.APP_VERSION;
const CI_PIPELINE_IID = process.env.CI_PIPELINE_IID;

const LOGENTRIES_TOKEN = process.env.LOGENTRIES_TOKEN;
const SENTRY_DSN = process.env.SENTRY_DSN;
const SENTRY_CLIENT_DNS = process.env.SENTRY_CLIENT_DNS;
const NEWRELIC_TOKEN = process.env.NEWRELIC_TOKEN;
const NEWRELIC_ENVIRONMENT = process.env.NEWRELIC_ENVIRONMENT;
const AUTHENTICITY_TOKEN = process.env.AUTHENTICITY_TOKEN;
const GOOGLE_ANALYTICS_ID = process.env.GOOGLE_ANALYTICS_ID;
const ADMIN_URL = process.env.ADMIN_URL;
const DISABLE_LOGS = process.env.DISABLE_LOGS;
const GA_MEASUREMENT_ID = process.env.GA_MEASUREMENT_ID;
const USE_INTERCOM_CHAT = process.env.USE_INTERCOM_CHAT;
const INTERCOM_CHAT_APP_ID = process.env.INTERCOM_CHAT_APP_ID;
const MOZZAZ_REDIRECT_URL = process.env.MOZZAZ_REDIRECT_URL;
const INTERCOM_SECRET_KEY = process.env.INTERCOM_SECRET_KEY;

module.exports = {
  ENV,
  PROD_ENV,
  DEV_ENV,
  ENV_NAME,
  APP_NAME,
  API_URI,
  CHAT_ATTACHMENTS_URI,
  CHAT_SOCKET_URI,
  BRAND_NAME,
  PAYA_ORIGIN,
  WEB_APP_URL,
  APP_STORE_APP_LINK,
  PLAY_MARKET_APP_LINK,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  REFRESH_SESSION_INTERVAL,
  WEB_PROVIDER_APP_URL,
  APP_VERSION,
  CI_PIPELINE_IID,

  LOGENTRIES_TOKEN,
  SENTRY_DSN,
  SENTRY_CLIENT_DNS,
  NEWRELIC_TOKEN,
  NEWRELIC_ENVIRONMENT,
  AUTHENTICITY_TOKEN,
  GOOGLE_ANALYTICS_ID,
  ADMIN_URL,
  DISABLE_LOGS,
  GA_MEASUREMENT_ID,
  USE_INTERCOM_CHAT,
  INTERCOM_CHAT_APP_ID,
  MOZZAZ_REDIRECT_URL,
  INTERCOM_SECRET_KEY,
};



// WEBPACK FOOTER //
// ./src/constants/env.js